import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useQueryClient } from 'react-query';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import { registerListener, isSocketConnected } from '../../services/socketService';
import { Message } from '../../services/messageService';

// TODO: Fetch chat header info (participant name)
// TODO: Implement MessageList & MessageInput

interface ChatWindowProps {
    selectedConversationId: number | null;
}

const ChatWindow: React.FC<ChatWindowProps> = ({ selectedConversationId }) => {
    const queryClient = useQueryClient();
    const [socketReady, setSocketReady] = useState(isSocketConnected());

    useEffect(() => {
        if (!selectedConversationId || !socketReady) return;

        console.log(`ChatWindow: Socket ready, registering listener for 'newMessage' on conversation ${selectedConversationId}`);
        const queryKey = ['messages', selectedConversationId];

        const cleanupListener = registerListener('newMessage', (newMessage: Message) => {
            console.log('ChatWindow: Received newMessage event:', newMessage);
            
            if (newMessage.conversationId === selectedConversationId) {
                 console.log(`ChatWindow: Invalidating messages query for conversation ${selectedConversationId}.`);
                queryClient.invalidateQueries(queryKey);
            }
        });

        return () => {
            console.log(`ChatWindow: Cleaning up listener for 'newMessage' on conversation ${selectedConversationId}`);
            cleanupListener();
        };

    }, [selectedConversationId, queryClient, socketReady]);

    useEffect(() => {
        const interval = setInterval(() => {
            const currentStatus = isSocketConnected();
            if (currentStatus !== socketReady) {
                console.log(`ChatWindow: Socket connection status changed to ${currentStatus}`);
                setSocketReady(currentStatus);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [socketReady]);

    if (!selectedConversationId) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center h-100 text-muted">
                <i className="fas fa-comments fa-3x mb-3"></i>
                <p>Select a conversation to start chatting.</p>
            </div>
        );
    }

    const participantName = `Conversation ${selectedConversationId}`;

    return (
        <div className="d-flex flex-column h-100">
            <Card.Header className="py-2 px-3 border-bottom">
                <h5 className="mb-0 fw-bold">{participantName}</h5> 
            </Card.Header>

            <div 
                className="flex-grow-1 overflow-auto p-3 message-list-area" 
                style={{ minHeight: 0 }}
            >
                <MessageList conversationId={selectedConversationId} />
            </div>

            <div className="p-3 border-top message-input-area">
                <MessageInput conversationId={selectedConversationId} />
            </div>
        </div>
    );
};

export default ChatWindow; 